import React from 'react';

export default function LinkMethod({method}) {
  return (
    <span className={`doc-portal-link-method doc-portal-link-method-${method}`}>
      {method}
    </span>
  );
}
